// extracted by mini-css-extract-plugin
export default {"outlet_content":"dashboardLayout_outlet_content__mBn4H","mobile_layout":"dashboardLayout_mobile_layout__1JBDK"};